module.exports = __webpack_public_path__ + "static/icons/icon-map--black-03e58e2122be9669b5db40aff7c3fb32.svg";